<template>
  <input
    v-bind:id="id"
    v-bind:name="id"
    v-on:change="onChange($event.target.value)"
    type="text"
    class="datepicker no-autoinit"
  />
</template>


<script>
import M from "materialize-css";
import jquery from "jquery";

export default {
  props: {
    id: String,
    value: String
  },
  mounted() {
    jquery(this.$el).parent().delegate('.modal-overlay', 'click', function(){ // close on overlay click
      M.Datepicker.getInstance(this.$el).close();
    }.bind(this));

    M.Datepicker.init(this.$el, this.generate_options());
  },
  methods: {
    generate_options: function() {
      return {
        autoClose: true,
        defaultDate: new Date(
          new Date().setFullYear(new Date().getFullYear() - 20)
        ), // now - 20 years
        yearRange: [new Date().getFullYear() - 120, new Date().getFullYear()], // [-120, now]
        minDate: new Date(
          new Date().setFullYear(new Date().getFullYear() - 120)
        ), // now - 120 years
        maxDate: new Date(), // now
        firstDay: 1,
        format: "dd/mm/yyyy",
        i18n: {
          done: "Ok",
          cancel: "annuler",
          clear: "effacer",
          months: [
            "janvier",
            "février",
            "mars",
            "avril",
            "mai",
            "juin",
            "juillet",
            "août",
            "septembre",
            "octobre",
            "novembre",
            "décembre"
          ],
          monthsShort: [
            "jan",
            "fév",
            "mars",
            "avr",
            "mai",
            "juin",
            "juil",
            "août",
            "sept",
            "oct",
            "nov",
            "déc"
          ],
          weekdays: [
            "dimanche",
            "lundi",
            "mardi",
            "mercredi",
            "jeudi",
            "vendredi",
            "samedi"
          ],
          weekdaysShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
          weekdaysAbbrev: ["D", "L", "M", "M", "J", "V", "S"]
        },
        onSelect: this.localizeDateFormat,
        onDraw: this.initDateFormat
      };
    },

    localizeDateFormat(selectedDate) {
      //this.value = M.Datepicker.getInstance(this.$el).toString();

      var shortWeekdays = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi"
      ];
      var shortMonths = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
      ];
      var day = selectedDate.getDate();
      var weekday = shortWeekdays[selectedDate.getDay()];
      var month = shortMonths[selectedDate.getMonth()];

      var formattedDate = weekday + " " + day + " " + month;

      jquery(this.$el)
        .find(".datepicker-date-display .date-text")
        .text(formattedDate);
    },

    initDateFormat(datePicker) {
      if (typeof datePicker.date === "undefined") {
        var calendarDate =
          datePicker.dateTextEl.innerHTML +
          " " +
          datePicker.yearTextEl.innerHTML;
        var newDate = new Date(calendarDate);
        if (typeof newDate === "object") {
          this.localizeDateFormat(newDate);
        }
      } else {
        this.localizeDateFormat(datePicker.date);
      }
    },

    get() {
      var instance = M.Datepicker.getInstance(this.$el);
      // console.log(instance.toString())
      return instance.date;
    },

    onChange: function(value) { // needed for v-model use in Travelers
      this.$emit("input", value);
    }
  }
};
</script>